import React from 'react'
import { Switch } from '@resurs/midas-react'

export class FormSwitch extends React.PureComponent {
  componentDidMount() {
    this.onChange(this.props.checked || this.props.defaultValue === 'true')
  }

  onChange(value) {
    this.props.isValid({
      key: this.props.id,
      valid: !this.props.required || value,
    })
    this.props.onChange(value || '')
  }

  render() {
    return (
      <Switch {...this.props} onChange={e => this.onChange(e.target.checked)} />
    )
  }
}
